const payable = () => import("@/pages/bill-manage/payable/index");
const payableImport = () => import("@/pages/bill-manage/payable/payable-import");
const contract = () => import("@/pages/bill-manage/contract/index");
const orderContract = () => import("@/pages/bill-manage/orderContract/index");


const receivable = () => import("@/pages/bill-manage/receivable/index");
const receivableImport = () => import("@/pages/bill-manage/receivable/receivable-import");
export default [
  {
    path: "bill-manage/orderContract",
    name: "orderContract",
    component: orderContract
  },
  {
    path: "bill-manage/contract",
    name: "contract",
    component: contract
  },
  {
    path: "bill-manage/payable",
    name: "bill-issue/payable",
    component: payable
  },
  {
    path: "bill-manage/payable-import",
    name: "payableImport",
    component: payableImport
  },

  {
    path: "bill-manage/receivable",
    name: "billManageReceivable",
    component: receivable
  },
  {
    path: "bill-manage/receivable-import",
    name: "receivableImport",
    component: receivableImport
  }
];



// WEBPACK FOOTER //
// ./src/router/bill-manage.js